export async function isValidBase64(str: string): Promise<boolean> {
  if (typeof str !== 'string' || str.trim() === '') {
    return false;
  }

  return await checkIfImage(str);
}

export function checkIfImage(base64Data: string): Promise<boolean> {
  return new Promise<boolean>((resolve: (value: boolean) => void): void => {
    const img = new Image();
    img.onload = (): void => {
      resolve(true);
    };
    img.onerror = (): void => {
      resolve(false);
    };
    img.src = `${base64Data}`;
  });
}

